/**
 * Site-wide formatting rules (per explicit product decisions):
 * - No decimal places on any monetary figure, EXCEPT "Estimated Value"
 *   fields specifically (a computed pro-rata figure where the approved
 *   reference design itself shows cents, e.g. $3,266,153.38).
 * - Dates always render as "DD Mon YYYY" (e.g. "01 Jan 2022") — two-digit
 *   day, short month name, full year — everywhere in the app.
 */

export function formatMoney(n: number | null | undefined, preserveCents = false): string {
  if (n === null || n === undefined) return "—";
  return "$" + n.toLocaleString("en-US", {
    maximumFractionDigits: preserveCents ? 2 : 0,
    minimumFractionDigits: preserveCents && n % 1 !== 0 ? 2 : 0,
  });
}

export function formatPercent(n: number | null | undefined): string {
  if (n === null || n === undefined) return "—";
  return n.toFixed(2) + "%";
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", { day: "2-digit", month: "short", year: "numeric" });
}
